(() => {
  const activationKeys = new Set(['Enter', ' ', 'Spacebar']);

  const initKeyboardActivation = (root = document) => {
    root
      .querySelectorAll(
        '[data-cv-e8e-controller]:not([data-cv-e8e-keyboard-ready]), [data-cv-e8e-final-cta]:not([data-cv-e8e-keyboard-ready])',
      )
      .forEach((scope) => {
        scope.dataset.cvE8eKeyboardReady = 'true';
        scope.addEventListener('keydown', (event) => {
          const button = event.target.closest('[data-cv-e8e-add], [data-cv-e8e-final-add], [data-cv-e8e-quantity-plus], [data-cv-e8e-quantity-minus]');
          if (!button || !scope.contains(button) || !activationKeys.has(event.key) || event.repeat) return;

          event.preventDefault();
          if (!button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
        });
      });
  };

  const syncBundleHelper = () => {
    const activeBundles = Boolean(document.querySelector('[data-cv-e8e-bundles-active]'));
    document.querySelectorAll('[data-cv-e8e-bundle-helper]').forEach((helper) => {
      helper.hidden = !activeBundles;
    });
  };

  const init = (root = document) => {
    syncBundleHelper();
    initKeyboardActivation(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', syncBundleHelper);
})();
